<script>
  export let item;
</script>

<div>
  {item?.qty}x @ ${item?.price} of {item?.name} - {item?.description}
</div>
